import { z } from 'zod';

export const translatedCheckPointSchema = z.object({
  id: z.string().optional(),
  checkPointId: z.string().nullish(),
  name: z.string().nullish(),
  description: z.string().nullish(),
});

export type TTranslatedCheckPointSchema = z.infer<
  typeof translatedCheckPointSchema
>;
